import { render, staticRenderFns } from "./Switchx.vue?vue&type=template&id=06c7daf8&"
import script from "./Switchx.vue?vue&type=script&lang=js&"
export * from "./Switchx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports